export const standardSubjects = [
    { color: '#FECE62', abbreviation: 'NE', subject: 'Nederlands' },
    { color: '#FBAC50', abbreviation: 'DU', subject: 'Duits' },
    { color: '#FF6F4A', abbreviation: 'EN', subject: 'Engels' },
    { color: '#FC85B4', abbreviation: 'FA', subject: 'Frans' },
    { color: '#E296DE', abbreviation: 'LB', subject: 'Levensbeschouwing' },
    { color: '#9A7EC1', abbreviation: 'NSK', subject: 'Natuur-scheikunde (nask)' },
    { color: '#E6BFD3', abbreviation: 'RE', subject: 'Rekenen' },
    { color: '#D34F6C', abbreviation: 'TN', subject: 'Techniek' },
    { color: '#AF64A1', abbreviation: 'WI', subject: 'Wiskunde' },
    { color: '#94BFCF', abbreviation: 'AK', subject: 'Aardrijkskunde' },
    { color: '#A5C6F4', abbreviation: 'EC', subject: 'Economie' },
    { color: '#477DA5', abbreviation: 'GE', subject: 'Geschiedenis' },
    { color: '#16BBDD', abbreviation: 'MIJ', subject: 'Maatschappijleer' },
    { color: '#22AC89', abbreviation: 'BI', subject: 'Biologie' },
    { color: '#4EDDB8', abbreviation: 'CKV', subject: 'CKV' },
    { color: '#78CB77', abbreviation: 'LO', subject: 'Lichamelijke opvoeding' },
    { color: '#AEC451', abbreviation: 'MT', subject: 'Mentoruur' },

    { color: '#FECE62', abbreviation: 'GD', subject: 'Godsdienst' },
    { color: '#FBAC50', abbreviation: 'MVI', subject: 'Media, vormgeving & ICT' },
    { color: '#FF6F4A', abbreviation: 'ZW', subject: 'Zorg & Welzijn' },
    { color: '#FC85B4', abbreviation: 'ADM', subject: 'Art, Design, Media' },
    { color: '#E296DE', abbreviation: 'BV', subject: 'Beeldende vorming' },
    { color: '#9A7EC1', abbreviation: 'TE', subject: 'Tekenen' },
    { color: '#E6BFD3', abbreviation: 'DR', subject: 'Drama' },
    { color: '#D34F6C', abbreviation: 'MU', subject: 'Muziek' },
    { color: '#AF64A1', abbreviation: 'GR', subject: 'Grieks' },
    { color: '#94BFCF', abbreviation: 'LA', subject: 'Latijn' },
    { color: '#A5C6F4', abbreviation: 'SP', subject: 'Spaans' },
    { color: '#477DA5', abbreviation: 'ST', subject: 'Studieles' },
    { color: '#16BBDD', abbreviation: 'IK', subject: 'Informatiekunde' },
    { color: '#22AC89', abbreviation: 'NA', subject: 'Natuurkunde' },
    { color: '#4EDDB8', abbreviation: 'SK', subject: 'Scheikunde' },
    { color: '#78CB77', abbreviation: 'WIA', subject: 'Wiskunde A' },
    { color: '#AEC451', abbreviation: 'WIB', subject: 'Wiskunde B' },

    { color: '#FECE62', abbreviation: 'AF', subject: 'Art Factory' },
    { color: '#FBAC50', abbreviation: 'BC', subject: 'Business Class' },
    { color: '#FF6F4A', abbreviation: 'CC', subject: 'Connecting Cultures' },
    { color: '#FF6F4A', abbreviation: 'LO2', subject: 'Lichamelijke opvoeding 2' },
    { color: '#FC85B4', abbreviation: 'EX', subject: 'Experience' },
    { color: '#FC85B4', abbreviation: 'BSM', subject: 'Bewegen, Sport en Maatschappij' },
    { color: '#E296DE', abbreviation: 'MD', subject: 'Multimedia Design' },
    { color: '#9A7EC1', abbreviation: 'MS', subject: 'Music Stage' },
    { color: '#E6BFD3', abbreviation: 'RS', subject: 'Research & Design' },
    { color: '#D34F6C', abbreviation: 'SP', subject: 'Sports' },
    { color: '#AF64A1', abbreviation: 'WB', subject: 'Wereldburgerschap' },
    { color: '#94BFCF', abbreviation: 'FI', subject: 'Filosofie' },
    { color: '#A5C6F4', abbreviation: 'DA', subject: 'Daltonuur' },
    { color: '#477DA5', abbreviation: 'OR', subject: 'Oriëntatieuur' },
    { color: '#16BBDD', abbreviation: 'WIC', subject: 'Wiskunde C' },
    { color: '#22AC89', abbreviation: 'WID', subject: 'Wiskunde D' },
    { color: '#4EDDB8', abbreviation: 'FI', subject: 'Fries' },
    { color: '#78CB77', abbreviation: 'CH', subject: 'Chinees' },
    { color: '#AEC451', abbreviation: 'TU', subject: 'Turks' }
];